import type { User } from '@/types/directory/User';
import type { ReviewAudience } from '@/types/review/ReviewAudience';

interface GetRevieweesParams {
    reviewAudience?: ReviewAudience;
    users?: User[];
}

export const getRevieweeIdsList = (reviewAudience: ReviewAudience): string[] => {
    return reviewAudience.reviewAudienceAssignments.map((assignment) => assignment.assignedTo);
};

export const getReviewersIdsList = (reviewAudience: ReviewAudience): string[] => {
    return reviewAudience.reviewAudienceAssignments.flatMap((assignment) =>
        assignment.reviewEvaluatorAssignments.map(
            (evaluatorAssignment) => evaluatorAssignment.assignedTo,
        ),
    );
};

export const getReviewees = ({ reviewAudience, users }: GetRevieweesParams): User[] => {
    if (!reviewAudience || !users) {
        return [];
    }

    const revieweeIds = getRevieweeIdsList(reviewAudience);

    return users.filter((user) => revieweeIds.includes(user.id));
};
